const geoDataEl: NodeListOf<HTMLElement> =
  document.querySelectorAll<HTMLElement>('[data-selector-geo]');
const currentUrl: string = window.location.href.split('/')[2];
const intDomain = 'int.roseskinco.com';

export const getCountry = async (): Promise<string> => {
  const response = await fetch('https://get.geojs.io/v1/ip/country.json');
  const { name: country } = await response.json();

  return country;
};

export const getDataLocations = async (): Promise<{
  [key: string]: { zone: string; countries: string[]; domain: string };
}> => {
  const geoData: string | null = geoDataEl[0]?.getAttribute('data-geo-values');
  if (geoData) {
    const splitDataGeo: string[] = geoData.split('|');
    const geoDataList: {
      [key: string]: { zone: string; countries: string[]; domain: string };
    } = {};
    const trimData: string[] = splitDataGeo.map((str: string) => str.trim());
    trimData.forEach((country: string) => {
      const [zone, countryList, domain]: string[] = country.split(':');
      let countries: string[] = countryList.split(',');
      countries = countries.map((country: any) => country.trim());
      geoDataList[zone] = {
        zone,
        countries,
        domain,
      };
    });

    return geoDataList;
  } else {
    return {} as {
      [key: string]: { zone: string; countries: string[]; domain: string };
    };
  }
};

const getZone = async (): Promise<string> => {
  const currentCountry: string = await getCountry();
  const geoDataList: { [key: string]: { countries: string[] } } =
    await getDataLocations();
  const currentZone: string | undefined =
    Object.keys(geoDataList).find((zone) =>
      geoDataList[zone].countries.includes(currentCountry)
    ) || 'International';

  return currentZone;
};

const getZoneDomain = async (): Promise<string | undefined> => {
  const geoDataList = await getDataLocations();
  const currentDomain: string | undefined = Object.keys(geoDataList).find(
    (zone) => geoDataList[zone].domain.includes(currentUrl)
  );

  return currentDomain;
};

export const getUrlRedirect = async (): Promise<string | boolean> => {
  const currentZone: string = await getZone();
  const geoDataList: { [key: string]: { domain: string } } =
    await getDataLocations();

  return currentZone === 'International'
    ? false
    : geoDataList[currentZone].domain;
};

export const rightStore = async (): Promise<boolean> => {
  const zone: string = await getZone();
  const domain: string | undefined = await getZoneDomain();

  return zone === domain;
};

export const intSubdomain = (): boolean => {
  return currentUrl === intDomain;
};

export const getQueryString = (): string => {
  const url: string = window.location.href;
  const query: string[] = url.split('?');

  return query[1];
};

export const getUrl = () => {
  const url = window.location.href;

  const urlSplitTail = url.split(currentUrl)[1];
  const paths = urlSplitTail === '/' ? '' : urlSplitTail;
  return paths;
};
